import { useEffect, useState } from 'react';
import { itemImage } from '@/lib/assets';
import { formatNumber } from '@/lib/utils';

interface RewardToastProps {
  doubloons?: number;
  xp?: number;
  marks?: number;
  message?: string;
  onDone: () => void;
}

export function RewardToast({
  doubloons,
  xp,
  marks,
  message,
  onDone,
}: RewardToastProps): JSX.Element {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 50);
    const hideTimer = setTimeout(() => setVisible(false), 4000);
    const doneTimer = setTimeout(onDone, 4600);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      clearTimeout(doneTimer);
    };
  }, [onDone]);

  return (
    <div
      className={`fixed top-6 left-1/2 -translate-x-1/2 z-[60] transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
      }`}
      role="status"
      aria-live="polite"
    >
      <div className="rounded-lg border-2 border-candle/60 bg-sea-deep/95 backdrop-blur-sm px-5 py-3 shadow-[0_4px_24px_rgba(232,177,75,0.3)] text-center min-w-[240px]">
        <p className="font-display text-sm uppercase tracking-[0.2em] text-candle mb-2">
          Quest Complete
        </p>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          {doubloons && (
            <div className="flex items-center gap-1.5">
              <img
                src={itemImage('doubloon')}
                alt=""
                aria-hidden
                className="h-6 w-6 object-contain"
                width={24}
                height={24}
              />
              <span className="font-mono text-lg text-candle">+{formatNumber(doubloons)}</span>
            </div>
          )}
          {xp && <span className="font-mono text-lg text-sea-foam">+{formatNumber(xp)} XP</span>}
          {marks && (
            <div className="flex items-center gap-1.5">
              <img
                src={itemImage('pirate_mark')}
                alt=""
                aria-hidden
                className="h-6 w-6 object-contain"
                width={24}
                height={24}
              />
              <span className="font-mono text-lg text-candle-bright">
                +{formatNumber(marks)} Marks
              </span>
            </div>
          )}
        </div>
        {message && <p className="text-xs text-parchment-dark mt-1.5 italic">{message}</p>}
      </div>
    </div>
  );
}
